import React from 'react';

const ArrowDown = () => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.410582 7.08924C0.736019 7.41467 1.26366 7.41467 1.58909 7.08924L5.99984 2.67849L10.4106 7.08924C10.736 7.41467 11.2637 7.41467 11.5891 7.08924C11.9145 6.7638 11.9145 6.23616 11.5891 5.91072L6.58909 0.910723C6.26366 0.585286 5.73602 0.585286 5.41058 0.910723L0.410582 5.91072C0.0851446 6.23616 0.0851446 6.7638 0.410582 7.08924Z"
        fill="#787F88"
      />
    </svg>
  );
};

export default ArrowDown;
